import { isAddress as isEvmAddress } from 'viem';
import type { WebsiteSupportedChains } from '@/lib/constants';
import { i18n } from '@/lib/i18n';
import { parseD9Address } from './d9';

function isTronAddress(address: string): boolean {
  if (address === '') return false;

  if (typeof window !== 'undefined') {
    const tronWeb = (
      window as { tronWeb?: { isAddress?: (addr: string) => boolean } }
    ).tronWeb;

    if (tronWeb?.isAddress) {
      try {
        return tronWeb.isAddress(address);
      } catch {
        // ignore and fallback to regex below
      }
    }
  }

  return /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(address);
}

/**
 * Normalize the receiver address for the given chain
 * @param chain
 * @param receiver
 * @returns
 * @throws {Error} if the receiver address is not valid
 */
export function normalizeReceiverAddress(
  chain: WebsiteSupportedChains,
  receiver: string,
): string {
  switch (chain) {
    case 'D9':
      try {
        return parseD9Address(receiver);
      } catch {
        throw new Error(i18n.t('validation.receiverAddressInvalidD9'));
      }
    case 'BSC':
      if (!isEvmAddress(receiver)) {
        throw new Error(i18n.t('validation.receiverAddressInvalidEVM'));
      }
      return receiver;
    case 'TRON':
      if (!isTronAddress(receiver)) {
        throw new Error(i18n.t('validation.receiverAddressInvalidTron'));
      }
      return receiver;
    default:
      throw new Error(i18n.t('validation.unsupportedChain'));
  }
}
